import type {
  MeasurementsCapabilityProvider,
  AngleMeasurementType,
} from '@trimble/web3d-providers';
import { createBaseMeasurementController } from '@trimble/measurements-shared';
import type { AngleMeasurementController } from './angle-measurement.types';

export function createAngleMeasurementController(
  provider: MeasurementsCapabilityProvider
): AngleMeasurementController {
  return {
    type: 'angle',
    ...createBaseMeasurementController<AngleMeasurementType>(provider),
  };
}
